import ForgotPassword from "../../pages/auth/ForgotPassword";
import Login from "../../pages/auth/Login";
import ResetPassword from "../../pages/auth/ResetPassword";
import SignUp from "../../pages/auth/SignUp";
import { ALL_ROUTES } from "../AllRoutes";

export const Auth_rouite_group = [
  {
    path: ALL_ROUTES?.LOGIN,
    element: Login,
  },
  {
    path: ALL_ROUTES?.SIGN_UP,
    element: SignUp,
  },
  { path: ALL_ROUTES?.FORGOT_PASSWORD, element: ForgotPassword },
  { path: ALL_ROUTES?.RESET_PASSWORD, element: ResetPassword },
];
